import {gql} from "apollo-angular";
import {baseResponse, baseResponseGraphqlField} from "src/app/store/base.graphql";

const ministryFields = `
    id
    ministryUniqueId
    ministryName
`;

export const CREATE_MINISTRY = gql`
    mutation CreateInstitutionMinistryMutation($input: InstitutionMinistriesInputObjects!) {
        createInstitutionMinistryMutation(input: $input) {
            data{
                ${ministryFields}
            }
            response{
                ${baseResponse}
            }
        }
    }
`;

export const UPDATE_MINISTRY = gql`
    mutation UpdateInstitutionMinistryMutation($input: InstitutionMinistriesInputObjects!) {
        updateInstitutionMinistryMutation(input: $input) {
            data{
                ${ministryFields}
            }
            response{
                ${baseResponse}
            }
        }
    }
`;

export const GET_ALL_MINISTRIES = gql`
query GetAllMinistries($filtering: MinistryFilteringInputObjects) {
  getAllMinistries(filtering: $filtering) {
            data{
                ${ministryFields}
            }
            response{
                ${baseResponse}
            }
        }
    }
`;

export const GET_USER_APPROVAL_ROSTER_MINISTRIES = gql`
query GetUserApprovalRosterMinistries {
  getUserApprovalRosterMinistries {
            data{
                ${ministryFields}
            }
            response{
                ${baseResponse}
            }
        }
    }
`;


